"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCache = void 0;

var _fastJsonStableStringify = _interopRequireDefault(require("fast-json-stable-stringify"));

var _react = _interopRequireDefault(require("react"));

var _LRUCache = require("./LRUCache");

var _types = require("./types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var useCache = function useCache(fetchPolicy, storage, storageMaxSize, link, variables) {
  if (!storage[_types.SYMBOL_DATA_PROVIDER]) {
    storage[_types.SYMBOL_DATA_PROVIDER] = new _LRUCache.LRUCache(storageMaxSize);
  }

  var cache = _react.default.useRef(storage[_types.SYMBOL_DATA_PROVIDER]).current;

  var shouldUseCache = fetchPolicy === _types.FetchPolicy.CacheFirst || fetchPolicy === _types.FetchPolicy.CacheAndNetwork;

  var getCacheKey = function getCacheKey(link, variables) {
    if (typeof link === 'string') {
      return "".concat(link, ":").concat((0, _fastJsonStableStringify.default)(variables));
    }

    return null;
  };

  var ifVal = function ifVal(x, fn) {
    return x ? fn : function () {
      return null;
    };
  };

  var partial = function partial(fn, presetArgs) {
    return function (args) {
      return fn(presetArgs, args);
    };
  };

  var readFromCache = function readFromCache(key) {
    if (key && cache.has(key)) {
      return cache.get(key);
    }

    return null;
  };

  var putCacheValue = function putCacheValue(key, value) {
    if (key) {
      return cache.set(key, value);
    }

    return null;
  };

  return {
    get: ifVal(shouldUseCache, partial(readFromCache, getCacheKey(link, variables))),
    reset: cache.reset,
    set: ifVal(shouldUseCache, partial(putCacheValue, getCacheKey(link, variables)))
  };
};

exports.useCache = useCache;